<template>
  <div class="forgetPassword">
    <div class="content">
      <p>{{ $tc('lang.Login.Forget_password') }}</p>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            :placeholder="$tc('lang.Login.Please_Number_mail')"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.Login.Please_Number_mail'),
                  },
                ],
              },
            ]"
          >
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-group compact>
            <a-input
              size="large"
              style="width: 65%"
              :placeholder="$tc('lang.Register.verification_code')"
              v-decorator="[
                'number',
                {
                  rules: [
                    {
                      required: true,
                      message: $tc('lang.Register.verification_code'),
                    },
                  ],
                },
              ]"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
            <a-button
              size="large"
              style="font-size: 12px; width: 35%; font-size: 16px"
              :disabled="
                code == $tc('lang.Register.Get_Verified') ? false : true
              "
              @click="getCode"
              >{{ code }}</a-button
            >
          </a-input-group>
        </a-form-item>
        <!-- 密码 -->
        <a-form-item>
          <a-input
            size="large"
              v-show="show==1"
            type="password"
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            v-decorator="[
              'cpassWord',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_New_password'),
                  },
                ],
              },
            ]"
          >
          <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="show=2"/>
          </a-input>
          <a-input
            size="large"
              v-show="show==2"
            type="text"
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            v-decorator="[
              'cpassWord',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_New_password'),
                  },
                ],
              },
            ]"
          >
          <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
                <a-icon slot="suffix"   type="eye-invisible"
                style="color:rgba(0,0,0,.25)" @click="show=1"/>
          </a-input>
        </a-form-item>
        <!-- 密码确认 -->
        <a-form-item>
          <a-input
            size="large"
            type="password"
             v-show="cshow==1"
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            v-decorator="[
              'passWord',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_New_password'),
                  },
                ],
              },
            ]"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
            <a-icon slot="suffix"   type="eye-invisible"
            style="color:rgba(0,0,0,.25)" @click="cshow=2"/>
          </a-input>
          <a-input
            size="large"
             v-show="cshow==2"
                type="text"
            :placeholder="$tc('lang.UserCenter.Check_New_password')"
            v-decorator="[
              'passWord',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.UserCenter.Check_New_password'),
                  },
                ],
              },
            ]"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
            <a-icon slot="suffix"   type="eye"
                style="color:rgba(0,0,0,.25)" @click="cshow=1"/>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            size="large"
            html-type="submit"
            class="button-pri"
          >
            {{ $tc('lang.UserCenter.Confirm') }}
          </a-button>
        </a-form-item>
      </a-form>

      <div class="bottom">
        <router-link to="/login">{{ $tc('lang.Login.Log_in') }}</router-link>
        <router-link to="/home">{{ $tc('lang.Login.Home_page') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      code: this.$tc('lang.Register.Get_Verified'),
      show:1,
      cshow: 1,
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if( values.passWord !== values.cpassWord){

          this.$message.error('两次密码不一致');
          return
          }     
          this.$http
            .post('/hzwmj/person/updatePassword', {
              loginUser: values.name,
              // personMobilephone: values.name,
              password: values.passWord,
              // personEmail: '',
              captcha: values.number,
              // personType: '3',
            })
            .then((data) => {
              if (data.data == '更改成功') {
                this.$message.success('success');
                this.$router.push('/login');
              } else {
                this.$message.error(data.data);
              }
            })
            .catch(() => {
              this.$message.error('error');
            });
          // console.log('Received values of form: ', values);
        }
      });
    },
    //手机获取验证码
    getCode() {
      this.form.validateFields(['name'], (err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/sendsms/sendMessageMail', {
              receiver: values.name,
            })
            .then((data) => {
              if (data) {
                console.log(data);
              } else {
                this.$message.error('获取失败');
              }
            })
            .catch(() => {
              this.$message.error('获取失败');
            });
        }
      });
      let time = 60;
      this.code = `${time}s`;
      let _this = this;
      let setTime = setInterval(function () {
        time--;
        _this.code = `${time}s`;
        if (time == 0) {
          _this.code = '获取验证码';
          clearInterval(setTime);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.forgetPassword {
  height: 100vh;
  background-image: url(./image/banner4.png);
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
  font-size: 16px;
  .ant-tabs-bar {
    margin-bottom: 24px;
    .ant-tabs-nav-container {
      font-size: 16px;
      color: #fff;
    }
  }
  .content {
    width: 420px;
    height: 420px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 20px 40px 40px;
    /*background-color: #fff;*/
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    .ant-form-item {
      margin-bottom: 28px;
    }
  }
  .ant-form-explain {
    text-align: left;
  }
  p {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    margin: 20px 0;
    text-align: center;
  }
  .button-pri {
    width: 100%;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    a {
      // color: rgba(0, 0, 0, 0.25);
      color: #fff;
    }
  }
}
</style>
